import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import styled from "styled-components"
import postContentStyle from "../styles/post-content"
// import kebabCase from "lodash/kebabCase"

const StyledPost = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 100px auto;
  background: #233140;
  /* justify-content: center; */
`

const StyledContentsWrapper = styled.div`
  width: 92%;
  margin: 50px auto;
  padding: 20px 0;
  /* background: darkgray; */
`

const StyledPostTitle = styled.h1`
  margin-bottom: 5px;
  font-size: 2rem;
`

const PostInfo = styled.div`
  margin-bottom: 50px;
`

const StyledPostDate = styled.span`
  margin: 0 10px 10px 0;
  color: gray;
`

const StyledPostCategory = styled.span`
  margin: 0 10px 10px 0;
  color: pink;
  text-transform: capitalize;
  display: inline-block !important;
`

const StyledPostContent = styled.div`
  margin-bottom: 50px;
  font-family: Roboto Mono;
  ${postContentStyle}
`

export default ({ data }) => {
  const post = data.markdownRemark
  const { title, date, category } = data.markdownRemark.frontmatter
  return (
    <Layout>
      <StyledPost>
        <StyledContentsWrapper>
          <StyledPostTitle>{title}</StyledPostTitle>
          <PostInfo>
            <StyledPostDate>{date}</StyledPostDate>
            <StyledPostCategory>{category}</StyledPostCategory>
          </PostInfo>
          <StyledPostContent dangerouslySetInnerHTML={{ __html: post.html }} />
        </StyledContentsWrapper>
      </StyledPost>
    </Layout>
  )
}

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        date(formatString: "YYYY/MM/DD")
        category
      }
    }
  }
`
